function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19.02"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2148",
  "data-name": "Rectangle 2148",
  fill: "none",
  d: "M0 0h19.999v19.02H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4991",
  "data-name": "Group 4991"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2797",
  "data-name": "Path 2797",
  d: "M10 0L0 7.264 3.82 19.02h12.36L20 7.264l-1.9-1.375-.867 1.193 1.027.746-3.157 9.717H4.891L1.735 7.828l8.265-6 .627.455.867-1.193z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4990",
  "data-name": "Group 4990",
  transform: "translate(0 -.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4989",
  "data-name": "Group 4989",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2798",
  "data-name": "Path 2798",
  d: "M16.819.262a3.547 3.547 0 103.546 3.547A3.547 3.547 0 0016.819.262m2.12 3.927H17.2v1.74h-.761v-1.74H14.7v-.76h1.739v-1.74h.761v1.74h1.74z",
  transform: "translate(-2.213 -.043)",
  fill: "#fff"
}))))));